export const obfuscateEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return '';
  }
  
  const [account, domain] = email.split("@");
  const obfuscatedAccount =
    account.length > 2
      ? account[0] +
        "*".repeat(account.length - 2) +
        account[account.length - 1]
      : account;
  return obfuscatedAccount + "@" + domain;
};
